import { render, staticRenderFns } from "./EcommerceLoadingDocuments.vue?vue&type=template&id=3c55b5b6&"
import script from "./EcommerceLoadingDocuments.vue?vue&type=script&lang=js&"
export * from "./EcommerceLoadingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports